@if (generateForm.formGroups) {
  <div class="flex gap-6">
    <div class="flex flex-col gap-y-7 w-full">
      <mat-expansion-panel
        [expanded]="isExpasion"
        (opened)="isExpasion = true"
        (closed)="isExpasion = false"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="py-4 text-general-subtitle text-(--color-text-title)">
              {{ generateForm.formGroups.title }}
              @if (edit) {
                - Descripción:
                {{
                  generateForm.formGroups.description !== ''
                    ? generateForm.formGroups.description
                    : '-'
                }}
                - DI:
                {{ generateForm.formGroups.idForm }}
              }
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        @switch (generateForm.formGroups.type) {
          @case ('generalForm') {
            <div class="lg:px-8 px-0 pb-4 pt-8 bg-white border-(--color-text-primary) border-t">
              <div
                class="grid gap-3"
                [ngClass]="{
                  'grid-cols-1': generateForm.formGroups.colummNum === 1,
                  'md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2':
                    generateForm.formGroups.colummNum === 2,
                  'md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3':
                    generateForm.formGroups.colummNum === 3,
                  'md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4':
                    generateForm.formGroups.colummNum === 4,
                }"
              >
                @if (
                  !generateForm.formGroups.hide || generateForm.formGroups.multifrom.length > 1
                ) {
                  @for (
                    multifrom of generateForm.formGroups.multifrom;
                    track multifrom;
                    let idx = $index
                  ) {
                    @if (generateForm.formGroups.isRepeatable) {
                      <div
                        class="w-full col-span-full text-(--color-text-primary) border-(--color-text-primary) text-general-subtitle border-b-2"
                      >
                        {{ idx + 1 + ': ' + generateForm.formGroups.title }}
                      </div>
                    }

                    @for (field of multifrom.fields; track field) {
                      @if (field.view && upRulesForm(field, multifrom.repeatIndex)) {
                        <div
                          class="w-full"
                          [ngClass]="{
                            'col-span-full':
                              field.typeInput === 'button-general' ||
                              field.colFull ||
                              $any(field).typeInput === 'reader-Table',

                            'overflow-auto': $any(field).typeInput === 'reader-Table',
                          }"
                        >
                          @if (edit) {
                            <div class="h-7">
                              <button
                                class="text-(--color-text-primary)"
                                (click)="
                                  emitInputEdit(generateForm.formGroups.idForm, field.idControl)
                                "
                                matButton
                                [matTooltip]="
                                  field.fieldName +
                                  ' => ' +
                                  field.idControl +
                                  '\n' +
                                  'Value: ' +
                                  field.formControl?.value
                                "
                              >
                                {{ field.fieldName + ' => ' + field.idControl | slice: 0 : 35 }}
                              </button>
                            </div>
                          }

                          @switch (field.typeInput) {
                            @case ('input-general') {
                              <app-input-general
                                [formControlGeneral]="field.formControl ?? null"
                                [maxlength]="
                                  field.error && field.error.maxlength
                                    ? field.error.maxlength
                                    : 524288
                                "
                                [label]="field.label"
                                [mask]="field.error && field.error.numberMask ? '0*' : ''"
                                [placeholder]="field.label"
                              ></app-input-general>
                            }
                            @case ('input-general-percentage') {
                              <app-input-general
                                [formControlGeneral]="field.formControl ?? null"
                                [mask]="field.mask"
                                [prefix]="field.prefix"
                                [suffix]="field.suffix"
                                [thousandSeparator]="field.thousandSeparator"
                                [allowNegativeNumbers]="field.allowNegativeNumbers"
                                [label]="field.label"
                                [placeholder]="field.label"
                              ></app-input-general>
                            }
                            @case ('input-general-currency') {
                              <app-input-general
                                [formControlGeneral]="field.formControl ?? null"
                                [mask]="field.mask"
                                [prefix]="field.prefix"
                                [suffix]="field.suffix"
                                [thousandSeparator]="field.thousandSeparator"
                                [allowNegativeNumbers]="field.allowNegativeNumbers"
                                [label]="field.label"
                                [placeholder]="field.label"
                              ></app-input-general>
                            }
                            @case ('input-general-number') {
                              <app-input-general
                                [formControlGeneral]="field.formControl ?? null"
                                [mask]="field.mask"
                                [prefix]="field.prefix"
                                [suffix]="field.suffix"
                                [thousandSeparator]="field.thousandSeparator"
                                [allowNegativeNumbers]="field.allowNegativeNumbers"
                                [label]="field.label"
                                [placeholder]="field.label"
                              ></app-input-general>
                            }
                            @case ('input-general-phone') {
                              <app-input-general
                                [formControlGeneral]="field.formControl ?? null"
                                [mask]="field.mask"
                                [prefix]="field.prefix"
                                [suffix]="field.suffix"
                                [thousandSeparator]="field.thousandSeparator"
                                [allowNegativeNumbers]="field.allowNegativeNumbers"
                                [label]="field.label"
                                [placeholder]="field.label"
                              ></app-input-general>
                            }
                            @case ('input-general-custom') {
                              <app-input-general
                                [formControlGeneral]="field.formControl ?? null"
                                [mask]="field.mask"
                                [prefix]="field.prefix"
                                [suffix]="field.suffix"
                                [thousandSeparator]="field.thousandSeparator"
                                [allowNegativeNumbers]="field.allowNegativeNumbers"
                                [label]="field.label"
                                [placeholder]="field.label"
                              ></app-input-general>
                            }
                            @case ('input-upload-ligh') {
                              <app-input-file-light
                                [formControlGeneral]="field.formControl ?? null"
                                [maxFileSizeMB]="field.maxFileSizeMB"
                                [label]="field.label"
                                [accept]="field.typeFile ? field.typeFile : ''"
                                [AdditionalValuesFiles]="field.AdditionalValuesFiles[0]"
                                (getFileService)="getFileLigh($event)"
                                (downloadFileService)="downloadFileLigh($event)"
                              ></app-input-file-light>
                            }
                            @case ('input-general-calendar') {
                              <app-input-general-calendar
                                [formControlGeneral]="field.formControl ?? null"
                                [label]="field.label"
                                [placeholder]="field.label"
                              ></app-input-general-calendar>
                            }
                            @case ('input-general-select') {
                              <app-input-general-select
                                [formControlGeneral]="field.formControl ?? null"
                                [arrayData]="field.arrayData"
                                [inputSelect]="field.inputSelect"
                                [label]="field.label"
                                [placeholder]="field.label"
                              ></app-input-general-select>
                            }
                            @case ('input-general-autocomplete') {
                              <app-input-general-autocomplete
                                [formControlGeneral]="field.formControl ?? null"
                                [arrayData]="field.arrayData"
                                [inputSelect]="field.inputSelect"
                                [label]="field.label"
                                [placeholder]="field.label"
                              ></app-input-general-autocomplete>
                            }
                            @case ('button-general') {
                              <div
                                class="col-span-full flex"
                                [ngClass]="
                                  isDeleteButton(field.function) ? 'justify-end' : 'justify-center'
                                "
                              >
                                <button
                                  (click)="
                                    inputFunction(field.function ? field.function : '', field)
                                  "
                                  class="text-center w-auto flex items-center gap-1"
                                  [ngClass]="
                                    isDeleteButton(field.function)
                                      ? 'button-general-delete max-w-40'
                                      : 'button-general px-4 h-12.75'
                                  "
                                  mat-menu-item
                                >
                                  @if (isDeleteButton(field.function)) {
                                    <mat-icon class="text-white!">delete</mat-icon>
                                  }
                                  {{ field.label }}
                                </button>
                              </div>
                            }
                            @case ('input-general-radio-button') {
                              <app-input-general-radio-button
                                [formControlGeneral]="field.formControl ?? null"
                                [arrayData]="field.arrayData"
                                [InputSelectRadioButton]="field.inputSelect"
                                [label]="field.label"
                                [placeholder]="field.label"
                              ></app-input-general-radio-button>
                            }
                            @case ('input-general-checkbox') {
                              <div class="h-18.25 flex items-center pb-5.5">
                                <mat-checkbox [formControl]="field.formControl!">{{
                                  field.label
                                }}</mat-checkbox>
                              </div>
                            }
                            @case ('input-general-text-area') {
                              <app-input-general-text
                                [formControlGeneral]="field.formControl ?? null"
                                [label]="field.label"
                                [placeholder]="field.label"
                              ></app-input-general-text>
                            }
                            @case ('reader-PDF') {
                              <app-reader-pdf [pdfReader]="field"></app-reader-pdf>
                            }
                            @case ('reader-Table') {
                              <app-reader-table
                                [url]="field.url"
                                [quotationId]="field.quotationId"
                              ></app-reader-table>
                            }

                            @case ('text-line') {
                              <div [innerHTML]="field.function"></div>
                            }
                          }
                        </div>
                      }
                      @if (
                        field.typeInput == 'break-line' && upRulesForm(field, multifrom.repeatIndex)
                      ) {
                        <div
                          class="w-full col-span-full"
                          [ngClass]="{
                            'bg-(--color-text-primary) h-px': field.view,
                          }"
                        ></div>
                      }
                    }
                  }
                }
              </div>
            </div>

            <mat-action-row class="px-4 py-1.5">
              <div class="flex justify-between w-full flex-wrap">
                <div>
                  <button
                    mat-icon-button
                    [matTooltip]="'4 columnas'"
                    (click)="generateForm.formGroups.colummNum = 4"
                  >
                    <mat-icon class="mb-1.25">view_cozy</mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    [matTooltip]="'3 columnas'"
                    (click)="generateForm.formGroups.colummNum = 3"
                  >
                    <mat-icon class="mb-1.25">view_cozy</mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    [matTooltip]="'2 columnas'"
                    (click)="generateForm.formGroups.colummNum = 2"
                  >
                    <mat-icon class="mb-1.25">view_cozy</mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    [matTooltip]="'1 columna'"
                    (click)="generateForm.formGroups.colummNum = 1"
                  >
                    <mat-icon class="mb-1.25">splitscreen_portrait</mat-icon>
                  </button>
                </div>
                <div class="flex gap-3 items-center lg:flex-row flex-col">
                  @if (generateForm.formGroups.isRepeatable) {
                    <button
                      (click)="addMultiform()"
                      class="button-general flex items-center text-center rounded-2xl justify-center gap-2 w-auto px-4 h-[2.625rem] min-h-[2.625rem]"
                      mat-menu-item
                    >
                      <mat-icon class="text-white!">add</mat-icon>
                      Agregar : {{ generateForm.formGroups.title }}
                    </button>
                  }

                  @if (toll && isExpasion) {
                    <app-tools-menu
                      [tollArray]="tollArray"
                      [hidenScrollRight]="hidenScrollRight"
                      [hidenScrollLeft]="hidenScrollLeft"
                      (emitButton)="
                        emitForm($event, generateForm.formGroups, generateForm.formGroups.title)
                      "
                    >
                    </app-tools-menu>
                  }
                </div>
              </div>
            </mat-action-row>
          }
        }
      </mat-expansion-panel>
    </div>
  </div>
}

<!-- Clases para html inyectado -->

<div class="h-0 w-0 m-5 px-8 text-red-400 hidden bg-green-400"></div>
<app-load-general [load]="loadService"></app-load-general>
